import React from 'react';
import Select from 'react-select';
const CustomDropdown = (props) => {
  const {
    id,
    isSearchable,
    controlHeight,
    height,
    placeholderMarginTop,
    placeholderColor,
    maxMenuHeight,
    defaultValue,
    placeholder,
    options,
    menuWidth,
    containerWidth,
    onChange,
    className,
    name,
    value,
    onBlur,
    controlStyles,
    placeholderStyles,
    showIndicator,
    isClearable,
    components,
    isDisabled,
    style,
    //
    border,
    menuIsOpen,
    isMulti,
    borderRadius,
    menuStyles,
    ...rest
  } = props;
  const customStyles = {
    option: (provided, state) => {
      return {
        ...provided,
        backgroundColor: state.isFocused
          ? '#dcefff'
          : state.isSelected
          ? '#51a5ec'
          : state.isDisabled
          ? '#b7b9c0'
          : 'white',
        '&:hover':
          !state.isDisabled && !state.isSelected && !state.isFocused
            ? {
                backgroundColor: '#dcefff',
                borderRadius: '5px',
                cursor: 'pointer',
              }
            : {},
        cursor: state.isDisabled ? 'not-allowed' : 'pointer',
        borderRadius: state.isSelected ? '5px' : '',
        color: '#021D33',
        padding: '9px',
      };
    },
    control: (provided) => ({
      ...provided,
      border: border || 'none',
      textAlign: 'left',
      fontSize: '18px',
      borderRadius: borderRadius || '32px',
      boxShadow: 'white',
      // cursor: 'pointer',
      minHeight: controlHeight || provided.minHeight,
      height: height || provided.height,
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      ...controlStyles,
    }),
    container: (provided) => ({
      ...provided,
      width: containerWidth || provided.width,
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '10px',
      textAlign: 'left',
      fontSize: '16px',
      width: menuWidth || provided.width,
      marginTop: '12px',
      boxShadow:
        '0 0 0 1px hsl(0deg 0% 0% / 0%), 0 4px 11px hsl(0deg 0% 0% / 10%)',
      zIndex: 10,
      ...menuStyles,
    }),
    singleValue: (provided) => ({
      ...provided,
      marginLeft: '10px',
    }),
    menuList: (provided) => ({
      ...provided,
      padding: '10px',
    }),
    placeholder: (provided) => ({
      ...provided,
      marginLeft: '10px',
      marginTop: placeholderMarginTop || provided.marginTop,
      ...placeholderStyles,
    }),
    input: (provided) => ({
      ...provided,
      marginLeft: '10px',
    }),
  };

  return (
    <Select
      isClearable={isClearable}
      options={options}
      id={id}
      name={name}
      className={className}
      instanceId={id}
      maxMenuHeight={maxMenuHeight}
      defaultValue={defaultValue ? defaultValue : null}
      placeholder={placeholder}
      isSearchable={isSearchable}
      styles={customStyles}
      components={
        components
          ? components
          : {
              IndicatorSeparator: () => null,
            }
      }
      onFocus={rest.onFocus}
      onChange={onChange}
      value={value}
      onBlur={onBlur}
      isMulti={isMulti}
      menuIsOpen={menuIsOpen}
      isDisabled={isDisabled}
      isOptionDisabled={(option) => option.disabled}
      {...rest}
    />
  );
};

export default CustomDropdown;
